import { render, staticRenderFns } from "./MtInvoices.vue?vue&type=template&id=6ad343fa&scoped=true&"
import script from "./MtInvoices.vue?vue&type=script&lang=js&"
export * from "./MtInvoices.vue?vue&type=script&lang=js&"
import style0 from "./MtInvoices.vue?vue&type=style&index=0&id=6ad343fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad343fa",
  null
  
)

export default component.exports